import React from "react";
import PropTypes from "prop-types";
import styles from "./FeedBanner.module.css";
import FeedTemplateIcon from "../FeedTemplateIcon";
import Button from "../Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClone } from "@fortawesome/free-solid-svg-icons";

/**
 * Interactive component. A banner that displays the feed title.
 * Also allows the user to save, reset, or draft changes.
 */
export function FeedBanner({
  feedType,
  feedTitle,
  status,
  isChangedOrNew,
  showDraft,
  isDraft,
  onCancel,
  onReset,
  onSave,
  onDraft,
}) {
  const handleSave = () => {
    onSave();
  };

  return (
    <div className={styles.container}>
      {status === "Create" ? (
        <>
          <div className={styles.cancelContainer}>
            <Button
              onClick={onCancel}
              text="Cancel"
              className={styles.cancelBtn}
            />
          </div>
        </>
      ) : (
        <>
          {feedType === "Standard Content" ? (
            <>
              <FeedTemplateIcon
                feedTemplateType="Standard Content"
                iconSize="36px"
              />
            </>
          ) : feedType === "Standing Order" ? (
            <>
              <FeedTemplateIcon
                feedTemplateType="Standing Order"
                iconSize="36px"
              />
            </>
          ) : (
            <>
              <FeedTemplateIcon feedTemplateType="Banner" iconSize="36px" />
            </>
          )}

          {status === "Clone" ||
          status === "New Clone" ||
          status === "Draft" ||
          status === "New Draft" ? (
            <>
              <div className={styles.cloneDiv}>
                <span className={styles.cloneText}>
                  <FontAwesomeIcon icon={faClone} className={styles.clone} />
                  CLONE |
                </span>
              </div>
              <h1 className={styles.feedTitle}>{feedTitle}</h1>
            </>
          ) : (
            <>
              <h1 className={styles.feedTitle}>{feedTitle}</h1>
            </>
          )}

          {isDraft && (
            <>
              <h1 className={styles.draftText}>| DRAFT VERSION </h1>
            </>
          )}

          {status === "New" ||
          status === "Edit" ||
          status === "Clone" ||
          status === "Draft" ? (
            <>
              <div className={styles.buttonContainer}>
                {isChangedOrNew && (
                  <span className={styles.saveText}>Save Changes?</span>
                )}
                <Button
                  onClick={onCancel}
                  text="Cancel"
                  className={styles.cancelBtn}
                />
                {isChangedOrNew && (
                  <>
                    <Button
                      onClick={onReset}
                      text="Reset"
                      className={styles.cancelBtn}
                    />

                    <Button
                      onClick={handleSave}
                      text="Save"
                      className={styles.saveBtn}
                    />
                  </>
                )}
              </div>
            </>
          ) : !isChangedOrNew ? (
            <>
              <div className={styles.buttonContainer}>
                <Button
                  onClick={onCancel}
                  text="Cancel"
                  className={styles.cancelBtn}
                />
              </div>
            </>
          ) : (
            <></>
          )}

          {isChangedOrNew && showDraft && (
            <>
              <Button
                onClick={onDraft}
                text="Save as Draft"
                className={styles.saveBtn}
              />
            </>
          )}
        </>
      )}
    </div>
  );
}

FeedBanner.propTypes = {
  // String that declares the feed type and determines the icon.
  feedType: PropTypes.oneOf(["Standard Content", "Standing Order", "Banner"]),
  // Optional string that states the feed item’s title.
  feedTitle: PropTypes.string,
  // String that determines the status of the feed item.
  status: PropTypes.oneOf([
    "Create",
    "New",
    "Edit",
    "Clone",
    "New Clone",
    "Draft",
    "New Draft",
  ]),
  // Boolean that determines whether the feed item is a draft or not.
  isDraft: PropTypes.bool,
  // Boolean that determines whether the feed item has a draft button or not
  showDraft: PropTypes.bool,
  // Boolean that determines whether the feed item has changed or is being created.
  isChanged: PropTypes.bool,
  //Function that fires when the cancel button is clicked.
  onCancel: PropTypes.func,
  //Function that fires when the reset button is clicked.
  onReset: PropTypes.func,
  //Function that fires when the save button is clicked
  onSave: PropTypes.func,
  //Optional function that fires when the draft button is clicked.
  onDraft: PropTypes.func,
};
